import React from 'react';
import styled from 'styled-components/macro';

const PleaseWait = styled.div`
  height: 100vh;
  justify-content: center;
  display: flex;
  align-items: center;
`;

export default () => (
  <PleaseWait>
    <p>please wait...</p>
  </PleaseWait>
);
